import ChannelList from '../components/ChannelList.jsx';
import Player from '../components/Player.jsx';

export default function WatchPage() {
  return (
    <>
      <ChannelList />
      <Player />
    </>
  );
}
